import type { Editor } from '@tiptap/core';
import { useContext, useEffect, useState } from 'react';

import { EditorContext } from './../../ricos-context';
import type { PublicCommands } from './../../ricos-types';

export const useEditorSelection = (editor: Editor) => {
  const { getPublicCommands } = useContext(EditorContext);

  const [selection, setSelection] = useState<ReturnType<PublicCommands['getSelection']>>(() =>
    getPublicCommands().getSelection()
  );

  useEffect(() => {
    const onSelectionUpdate = () => {
      setSelection(getPublicCommands().getSelection());
    };

    editor.on('selectionUpdate', onSelectionUpdate);

    return () => {
      editor.off('selectionUpdate', onSelectionUpdate);
    };
  }, []);

  return selection;
};
